import { ReactNode, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext.js";

const NAV = [
  { to: "/", label: "Resumen", icon: "◈" },
  { to: "/influencers", label: "Influencers", icon: "✦" },
  { to: "/ideas", label: "Ideas", icon: "💡" },
  { to: "/sessions", label: "Sesiones", icon: "🎬" },
  { to: "/catalog", label: "Catálogo", icon: "🛍" },
  { to: "/scenarios", label: "Escenarios", icon: "🌆" },
  { to: "/calendar", label: "Calendario", icon: "📅" },
  { to: "/results", label: "Resultados", icon: "📊" },
  { to: "/costs", label: "Costes", icon: "💰" },
  { to: "/settings/providers", label: "Proveedores", icon: "⚙" },
  { to: "/settings/autonomy", label: "Autonomía", icon: "🤖" },
];

const linkStyle = ({ isActive }: { isActive: boolean }) => ({
  display: "flex",
  alignItems: "center",
  gap: 8,
  padding: "8px 16px",
  textDecoration: "none",
  color: isActive ? "#2d6a4f" : "#444",
  background: isActive ? "#d8f3dc" : "transparent",
  borderRadius: 6,
  fontWeight: isActive ? 600 : 400,
  fontSize: 14,
});

export function Layout({ children }: { children: ReactNode }) {
  const { logout, role } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  async function handleLogout() {
    await logout();
    navigate("/login");
  }

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#f8f6f0" }}>
      {/* Sidebar desktop */}
      <aside style={{
        width: 220, background: "#fff", borderRight: "1px solid #e8e4dc",
        display: "flex", flexDirection: "column", padding: "24px 12px",
        position: "sticky", top: 0, height: "100vh", overflowY: "auto",
      }}
        className="sidebar-desktop"
      >
        <div style={{ marginBottom: 24, paddingLeft: 8 }}>
          <div style={{ fontSize: 18, fontWeight: 700, color: "#1a1a1a" }}>Autoexistencia</div>
          <div style={{ fontSize: 11, color: "#888", marginTop: 2 }}>Rol: {role}</div>
        </div>
        <nav style={{ display: "flex", flexDirection: "column", gap: 2, flex: 1 }}>
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.to === "/"} style={linkStyle}>
              <span style={{ width: 18, textAlign: "center" }}>{n.icon}</span>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <button onClick={handleLogout} style={{
          marginTop: 16, padding: "8px 16px", border: "1px solid #ddd",
          borderRadius: 6, background: "none", cursor: "pointer", fontSize: 13, color: "#666"
        }}>Cerrar sesión</button>
      </aside>

      {/* Main */}
      <main style={{ flex: 1, padding: "32px 32px 64px", maxWidth: "100%", overflowX: "hidden" }}>
        {/* Mobile header */}
        <div className="mobile-header" style={{ display: "none", marginBottom: 16 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span style={{ fontWeight: 700 }}>Autoexistencia</span>
            <button onClick={() => setMenuOpen(!menuOpen)} style={{ border: "none", background: "none", fontSize: 20 }}>☰</button>
          </div>
          {menuOpen && (
            <nav style={{ display: "flex", flexDirection: "column", gap: 2, marginTop: 8, background: "#fff", padding: 8, borderRadius: 8 }}>
              {NAV.map((n) => (
                <NavLink key={n.to} to={n.to} end={n.to === "/"} style={linkStyle} onClick={() => setMenuOpen(false)}>
                  <span>{n.icon}</span> {n.label}
                </NavLink>
              ))}
              <button onClick={handleLogout} style={{ marginTop: 8, padding: "8px 16px", border: "1px solid #ddd", borderRadius: 6, background: "none", cursor: "pointer" }}>
                Cerrar sesión
              </button>
            </nav>
          )}
        </div>
        {children}
      </main>

      <style>{`
        @media (max-width: 768px) {
          .sidebar-desktop { display: none !important; }
          .mobile-header { display: block !important; }
          main { padding: 16px !important; }
        }
      `}</style>
    </div>
  );
}
